// Spanish UI labels — STUB, flagged for translation.
// Empty by design: falls back to English (en.js) per key. Human translation
// only. Copy the key structure from en.js, translate, then flip
// `translated: true` in i18n/languages.js.
export default {}
